import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const UpiStepWrapper = styled.div({
    display: "flex",
    flexDirection: "column",
    position: "relative",
});

export const LottieContainer = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing.xxSmall,
}));

export const ContentSection = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing.large,
}));

export const UpiStepHeading = styled(Text)(({ theme }) => ({
    padding: `0 ${theme.spacing.medium}`,
}));

export const UpiTextFieldSection = styled.div(({ theme }) => ({
    marginTop: theme.spacing.xLarge,
    marginBottom: theme.spacing.xxLarge,
    position: "relative",
}));

export const DisabledChipsOverlay = styled.div(({ theme }) => ({
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: theme.spacing.xLarge,
    cursor: "not-allowed",
    zIndex: 1,
}));
